import React, { useEffect, useRef } from "react";

import Chart from "chart.js/auto";
import "chartjs-adapter-luxon";

export default function LineChart(props) {
  const { data } = props;

  const chartRef = useRef(null);
  let myChart = null;

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d");

    myChart = new Chart(ctx, {
      type: "line",
      data: data,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: false,
            // text: "Enrollment over Time",
          },
          legend: { position: "bottom" },
        },
        interaction: {
          intersect: false,
        },
        scales: {
          x: {
            display: true,
            title: {
              display: true,
            },
            type: "time",
            time: {
              // Luxon format string
              tooltipFormat: "DD",
            },
          },
          y: {
            display: true,
            title: {
              display: true,
              text: "Subjects Enrolled",
            },
            // suggestedMin: -10,
            // suggestedMax: 200,
          },
        },
      },
    });

    return () => {
      if (myChart) {
        myChart.destroy();
      }
    };
  }, [data]);

  return <canvas ref={chartRef}></canvas>;
}
